/**
 * Query keys for Users API hooks
 *
 * Centralized query keys enable consistent cache invalidation across user hooks.
 */
export const usersQueryKeys = {
  all: ['users'] as const,
  search: (filter: string, brand: string, limit?: number) =>
    [...usersQueryKeys.all, 'search', filter, brand, ...(limit != null ? [limit] : [])] as const,
  summaries: () => [...usersQueryKeys.all, 'summaries'] as const,
  summariesByIds: (brand: string, ids: Array<string>) => [...usersQueryKeys.summaries(), brand, { ids }] as const,
  identityProviders: () => [...usersQueryKeys.all, 'identityProviders'] as const,
  accountIdentityLists: () => [...usersQueryKeys.all, 'accountIdentityLists'] as const,
  accountIdentityList: (accountId: string) => [...usersQueryKeys.accountIdentityLists(), accountId] as const,
};
